import { ref, onMounted, onBeforeUnmount, computed } from "vue";

export const useResponsive = () => {
  const isBelowMdBreakpoint = ref(false);
  const isTabletBreakpoint = ref(false);

  const setBreakpointToggle = () => {
    isBelowMdBreakpoint.value = window.matchMedia("(max-width: 767.98px)").matches;
    isTabletBreakpoint.value = window.matchMedia("(min-width: 767.98px) and (max-width: 991px)").matches;
  };

  onMounted(() => {
    window.addEventListener("resize", setBreakpointToggle);
    setBreakpointToggle();
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", setBreakpointToggle);
  });

  const isViewportMobile = computed(() => isBelowMdBreakpoint.value);
  const isViewportTablet = computed(() => isTabletBreakpoint.value);
  const isViewportMobileOrTablet = computed(() => isBelowMdBreakpoint.value || isTabletBreakpoint.value);
  const isViewportDesktop = computed(() => !isBelowMdBreakpoint.value && !isTabletBreakpoint.value);

  return {
    isViewportMobile,
    isViewportTablet,
    isViewportMobileOrTablet,
    isViewportDesktop,
  };
};
